import { render, staticRenderFns } from "./k-table-card.vue?vue&type=template&id=e0d9bcdc&"
import script from "./k-table-card.vue?vue&type=script&lang=ts&"
export * from "./k-table-card.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports